import axios from 'axios';

const createClient = (baseURL, { subscriptionId, financialYear } = {}) => {
  const headers = { 'Content-Type': 'application/json' };
  if (subscriptionId) headers['SubscriptionId'] = String(subscriptionId);
  if (financialYear) headers['financialYear'] = String(financialYear);
  return axios.create({ baseURL, headers, withCredentials: true });
};

const handleError = (error) => {
  const status = error?.response?.status;
  const serverMsg = error?.response?.data?.message;
  if (status === 401) return { status: false, message: serverMsg || 'Session expired. Please scan the QR code again.' };
  if (status === 403) return { status: false, message: serverMsg || 'Access denied. You do not have permission.' };
  if (status === 404) return { status: false, message: serverMsg || 'Requested resource not found.' };
  if (status === 500) return { status: false, message: serverMsg || 'Server error. Please try again later.' };
  return { status: false, message: serverMsg || error?.message || 'Something went wrong. Please try again.' };
};

const get = async (baseUrl, path, opts = {}) => {
  try {
    const client = createClient(baseUrl, opts);
    const response = await client.get(path);
    return response?.data;
  } catch (error) {
    return handleError(error);
  }
};

const post = async (baseUrl, path, payload, opts = {}) => {
  try {
    const client = createClient(baseUrl, opts);
    const response = await client.post(path, payload);
    return response?.data;
  } catch (error) {
    return handleError(error);
  }
};

// Change this to your local API URL for development, or production URL for deployment
 const SERVER_BASE_URL = "https://businessapi.stayerly.com";
//const SERVER_BASE_URL = "https://localhost:7207";

export async function ListItemCategory(restaurantId, { subscriptionId, financialYear } = {}) {
    return get(SERVER_BASE_URL, `/api/v1/Order/digitalMenu/itemCategory/list?restaurantId=${restaurantId}`, { subscriptionId, financialYear });
}

export async function GetSubItemCategory(categoryId, { subscriptionId, financialYear } = {}) {
    return get(SERVER_BASE_URL, `/api/v1/Order/digitalMenu/subItemCategory/get?categoryId=${categoryId}`, { subscriptionId, financialYear });
}

export async function GetItem(restaurantId, categoryId, { subscriptionId, financialYear } = {}) {
    if (!restaurantId || !categoryId || !subscriptionId) {
        const missing = [!restaurantId && 'restaurantId', !categoryId && 'categoryId', !subscriptionId && 'subscriptionId'].filter(Boolean);
    return { status: false, message: `Missing required info: ${missing.join(', ')}. Please scan the QR code again.` };
  }
    return get(SERVER_BASE_URL, `/api/v1/Order/digitalMenu/item/get?restaurantId=${restaurantId}&categoryId=${categoryId}`, { subscriptionId, financialYear });
}

export async function GetItemByRestaurantId(id, { subscriptionId, financialYear } = {}) {
  return get(SERVER_BASE_URL, `/api/v1/Order/digitalMenu/item_restaurantId/get?id=${id}`, { subscriptionId, financialYear });
}

export async function AddRestaurantOrder(data, { subscriptionId, financialYear } = {}) {
  return post(SERVER_BASE_URL, '/api/v1/Order/digitalMenu/restaurant_order/add', data, { subscriptionId, financialYear });
}
